//ToDo: Write e2e tests for Audio player since we are unable to test with RTL
import Container from './container'

export default Container
